module.exports = __webpack_public_path__ + "img/img2.505f5f9a.png";